// extracted by mini-css-extract-plugin
module.exports = {"container":"article-change-tool_container__7Dx1V","docCom":"article-change-tool_docCom__S3oZ9"};